var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.transitionComponent,_vm._g(_vm._b({tag:"component",attrs:{"tag":_vm.tag}},'component',_vm.$attrs,false),_vm.transitionListeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }